"use strict";
/* eslint-disable no-shadow */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductPlans = exports.Products = void 0;
var Products;
(function (Products) {
    Products["ORGANIC"] = "organic";
    Products["COMMUNITY_SURVEY"] = "community-survey";
    Products["CX_SURVEYS"] = "cx-surveys";
    Products["ENGAGE"] = "engage";
    Products["GOVFLOW"] = "govflow";
    Products["BLOCKWISE"] = "blockwise";
    Products["PULSE"] = "pulse";
})(Products = exports.Products || (exports.Products = {}));
var ProductPlans;
(function (ProductPlans) {
    ProductPlans["ESSENTIALS"] = "essentials";
    ProductPlans["PRO"] = "pro";
})(ProductPlans = exports.ProductPlans || (exports.ProductPlans = {}));
